import Vue from "vue";
import VueProgressBar from "vue-progressbar";
import VueSweetalert2 from "vue-sweetalert2";
import vSelect from "vue-select";
import { VueSpinners } from "@saeris/vue-spinners";
import * as VueGoogleMaps from "vue2-google-maps";
import Vuelidate from "vuelidate";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VuePivottable from "vue-pivottable";
import VueFormWizard from 'vue-form-wizard';

import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import "vue-pivottable/dist/vue-pivottable.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "vue-select/dist/vue-select.css";

Vue.config.productionTip = false;

store.dispatch("getUser");

const HEMOLIFE_RED = "#e53538";
const HEMOLIFE_BLUE = "#4e6990";

const options = {
  color: HEMOLIFE_RED,
  thickness: "6px",
  autoRevert: true,
  transition: {
    speed: "0.3s",
    opacity: "0.4s",
    termination: 400,
  },
  inverse: false,
};

const optionsSwal = {
  confirmButtonColor: HEMOLIFE_RED,
  cancelButtonColor: HEMOLIFE_BLUE,
};

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCHeKQcUexgFjAZPwHdSqRX7ofAX4DSv6c",
    libraries: ["places", "geometry"],
  },
});

Vue.use(VueProgressBar, options);
Vue.use(VueSweetalert2, optionsSwal);
Vue.use(VueSpinners);
Vue.use(VuePivottable);
Vue.use(Vuelidate);
Vue.use(VueFormWizard);
Vue.component("v-select", vSelect);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

